<h1 class="mb-4">Wnioski wysłane</h1>
<div class="flex flex-col mb-4">
  <p class="font-bold mb-1">Filtrowanie</p>
  <div class="flex gap-2">
    <p-button
      (click)="toggleInboxType(InboxType.TO_RECEIVE)"
      [icon]="inboxType() === InboxType.TO_RECEIVE ? 'pi pi-times' : ''"
      [styleClass]="
        'customInfoButton' +
        (inboxType() === InboxType.TO_RECEIVE ? '' : ' outlined')
      "
      iconPos="right"
      label="Wysłane"
      size="small"
    ></p-button>

    <p-button
      (click)="toggleInboxType(InboxType.ARCHIVED)"
      [icon]="inboxType() === InboxType.ARCHIVED ? 'pi pi-times' : ''"
      [styleClass]="
        'customInfoButton' +
        (inboxType() === InboxType.ARCHIVED ? '' : ' outlined')
      "
      iconPos="right"
      label="Zarchiwizowane"
      size="small"
    ></p-button>
  </div>
</div>
<div class="wide">
  <p-table
    #table
    (onPage)="onPrimePageChange($event)"
    (onSort)="onPrimeSortChange($event)"
    [(selection)]="selectedDocuments"
    [customSort]="true"
    [lazy]="true"
    [loading]="isDataLoading()"
    [paginatorStyleClass]="'customPrimePaginator'"
    [paginator]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [rowSelectable]="isRowSelectable"
    [rows]="this.tablePage()?.size || 10"
    [tableStyle]="{ 'min-width': '50rem' }"
    [totalRecords]="this.tablePage()?.totalElements || 0"
    [value]="rows()"
    dataKey="id"
    [scrollable]="true"
    scrollHeight="flex"
  >
    <ng-template #header>
      <tr>
        <td class="table-filter-cell" style="width: 4rem">
          <p-tableHeaderCheckbox />
        </td>
        <th pSortableColumn="typDokumentu.kod">
          <div class="flex items-center gap-2">
            Nazwa wniosku
            <p-sortIcon field="code" />
          </div>
        </th>
        <th pSortableColumn="adresat">
          <div class="flex items-center gap-2">
            Adresat
            <p-sortIcon field="adresat" />
          </div>
        </th>
        <th pSortableColumn="nrDokumentu">
          <div class="flex items-center gap-2">
            Numer dokumentu
            <p-sortIcon field="nrDokumentu" />
          </div>
        </th>
        <th pSortableColumn="dataWplywu" style="width: 200px; min-width: 200px">
          <div class="flex items-center gap-2">
            Data wysłania
            <p-sortIcon field="dataWplywu" />
          </div>
        </th>
        <th alignFrozen="right" pFrozenColumn>Akcje</th>
      </tr>
      <tr>
        <td></td>
        <td class="table-filter-cell">
          <p-select
            (onChange)="onPrimeFilterChange($event.value, 'typDokumentu')"
            [options]="dropdownValue()"
            [filter]="true"
            filterBy="label"
            filterPlaceholder="Wyszukaj rodzaj wniosku"
            [showClear]="true"
            appControlError
            appendTo="body"
            class="w-full"
            optionLabel="label"
            placeholder="Wybierz rodzaj wniosku"
            ariaLabel="Filtruj po rodzaju wniosku"
          >
            <ng-template #item let-option>
              <div class="select-item">
                {{ option.label }}
              </div>
            </ng-template>
          </p-select>
        </td>
        <td class="table-filter-cell">
          <input
            (change)="onPrimeFilterChange($event.target, 'adresat')"
            ariaLabel="Filtruj po adresacie"
            pInputText
          />
        </td>
        <td class="table-filter-cell">
          <input
            (change)="onPrimeFilterChange($event.target, 'nrDokumentu')"
            ariaLabel="Filtruj po numerze dokumentu"
            pInputText
          />
        </td>
        <td style="width: 200px; min-width: 200px" class="table-filter-cell">
          <p-date-picker
            (onClear)="onPrimeFilterChange($event, 'dataWplywu')"
            (onSelect)="onPrimeFilterChange($event, 'dataWplywu')"
            [readonlyInput]="true"
            [showClear]="true"
            appendTo="body"
            class="w-full"
            dateFormat="dd-mm-yy"
            ariaLabel="Filtruj po rodzaju dacie wpływu"
          />
        </td>
        <td alignFrozen="right" pFrozenColumn></td>
      </tr>
    </ng-template>
    <ng-template #body let-document>
      <tr>
        <td>
          <p-tableCheckbox
            [value]="document"
            [disabled]="document | isAdresatZus"
            [pTooltip]="
              (document | isAdresatZus)
                ? 'Wykonanie akcji masowych dla wniosków wysyłanych do ZUS jest nieaktywne.'
                : undefined
            "
            tooltipPosition="bottom"
            ariaLabel="Zaznaczanie wiersza tablicy"
          />
        </td>
        <td>{{ document.typDokumentu?.nazwa }}</td>
        <td>{{ document.adresat }}</td>
        <td>{{ document.nrDokumentu }}</td>
        <td>{{ document.dataWplywu | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
        <td alignFrozen="right" pFrozenColumn class="h-16 align-middle">
          <div class="flex items-center h-full gap-3 justify-end">
            @if (document | shouldShowCorrespondenceIcon: inboxType()) {
              <p-button
                type="button"
                class="icon_correspondence"
                (click)="createNewDokument(document)"
                ariaLabel="Koresponduj w sprawie"
                pTooltip="Koresponduj w sprawie"
                tooltipPosition="top"
                [rounded]="true"
                [text]="true"
              >
              </p-button>
            }
            <p-button
              type="button"
              (click)="openShowApplicationModal(document)"
              ariaLabel="Zobacz szczegóły"
              pTooltip="Zobacz szczegóły"
              tooltipPosition="top"
              [rounded]="true"
              [text]="true"
            >
              <i class="pi pi-eye icon_show" aria-hidden="true"></i>
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="flex justify-between gap-2 mt-4">
    <div class="flex gap-2 mt-2">
      @if (inboxType() === InboxType.TO_RECEIVE) {
        <p-button
          styleClass="customInfoButton outlined"
          size="small"
          label="Archiwizuj wybrane"
          [disabled]="!selectedDocuments.length"
          (click)="archiveDocumentDialog()"
        />
        <p-button
          styleClass="customInfoButton outlined"
          size="small"
          label="Eksportuj wybrane"
          [disabled]="!selectedDocuments.length"
          (click)="exportSelected()"
        />
      }

      @if (inboxType() === InboxType.ARCHIVED) {
        <p-button
          styleClass="customInfoButton outlined"
          size="small"
          label="Cofnij archiwizację wybranych"
          [disabled]="!selectedDocuments.length"
          (click)="restoreFromArchiveDocumentDialog()"
        />
        <p-button
          styleClass="customInfoButton outlined"
          size="small"
          label="Eksportuj wybrane"
          [disabled]="!selectedDocuments.length"
          (click)="exportSelected()"
        />
      }

      @if (inboxType() === InboxType.ALL) {
        <p-button
          styleClass="customInfoButton outlined"
          size="small"
          label="Eksportuj wybrane"
          [disabled]="!selectedDocuments.length"
          (click)="exportSelected()"
        />
      }
    </div>
  </div>
</div>
<div class="narrow">
  <div class="flex flex-col gap-4 mb-6">
    <div class="flex flex-col gap-2">
      <span id="typDokumentu" class="font-bold">Rodzaj wniosku</span>
      <p-select
        (onChange)="onPrimeFilterChange($event.value, 'typDokumentu')"
        [options]="dropdownValue()"
        [filter]="true"
        filterBy="label"
        filterPlaceholder="Wyszukaj rodzaj wniosku"
        [showClear]="true"
        [(ngModel)]="tableFilters.documentType"
        class="customSelect"
        ariaLabelledBy="typDokumentu"
        optionLabel="label"
        placeholder="Wybierz rodzaj wniosku"
      >
        <ng-template #item let-option>
          <div class="select-item">
            {{ option.label }}
          </div>
        </ng-template>
      </p-select>
    </div>
    <div class="flex flex-col gap-2">
      <label for="adresat" class="font-bold">Adresat</label>
      <input
        (input)="onPrimeFilterChangeMobile($event.target, 'adresat')"
        id="adresat"
        [(ngModel)]="tableFilters.sender"
        pInputText
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="nrDokumentu" class="font-bold">Numer dokumentu</label>
      <input
        (input)="onPrimeFilterChangeMobile($event.target, 'adresat')"
        id="nrDokumentu"
        [(ngModel)]="tableFilters.documentNumber"
        pInputText
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="dataWyslania" class="font-bold">Data wysłania</label>
      <p-date-picker
        (onClear)="onPrimeFilterChange($event, 'dataWplywu')"
        (onSelect)="onPrimeFilterChange($event, 'dataWplywu')"
        [readonlyInput]="true"
        [showClear]="true"
        [(ngModel)]="tableFilters.sentDate"
        appendTo="body"
        class="w-full customDatePicker"
        dateFormat="dd-mm-yy"
        inputId="dataWyslania"
        [showIcon]="true"
        [iconDisplay]="'input'"
      />
    </div>
    <div class="flex flex-row-reverse gap-2">
      <p-button
        type="button"
        styleClass="customInfoButton outlined"
        (click)="clearFilters()"
        ariaLabel="Wyczyść filtry"
      >
        <span class="font-bold">Wyczyść filtry</span>
      </p-button>
    </div>
  </div>
  @if (isDataLoading()) {
    <div class="flex justify-center">
      <p-progress-spinner
        class="customProgressSpinner"
        strokeWidth="6"
        fill="transparent"
        animationDuration=".5s"
        [style]="{ width: '50px', height: '50px' }"
      >
      </p-progress-spinner>
    </div>
  } @else {
    <div class="flex flex-col gap-10">
      @for (document of rows() || []; track document.id; let index = $index) {
        <p-card>
          <div class="mb-2">
            <span
              (click)="showMobilePopoverIfZus($event, document)"
              class="inline-flex align-items-center"
            >
              <p-checkbox
                [(ngModel)]="selectedDocuments"
                [value]="document"
                [disabled]="document | isAdresatZus"
              ></p-checkbox>
            </span>

            <p-popover #pop>
              Wykonanie akcji masowych dla wniosków wysyłanych do ZUS jest
              nieaktywne.
            </p-popover>
          </div>
          <div class="flex flex-col">
            <app-preview-data-wrapper
              label="Nazwa wniosku"
              [data]="document.typDokumentu?.nazwa"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Adresat"
              [data]="document.adresat"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Numer dokumentu"
              [data]="document.nrDokumentu"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Data wysłania"
              [dataType]="PreviewDataType.DATE"
              [data]="document.dataWplywu"
            ></app-preview-data-wrapper>

            <div class="flex justify-end gap-5 mt-5">
              <p-button
                (click)="openShowApplicationModal(document)"
                label="Szczegóły"
                styleClass="customInfoButton outlined"
              />
            </div>
          </div>
        </p-card>
      }
      <div class="flex gap-2 sticky-actions justify-evenly">
        @if (inboxType() === InboxType.TO_RECEIVE) {
          <p-button
            styleClass="customInfoButton outlined"
            label="Archiwizuj wybrane"
            [disabled]="!selectedDocuments.length"
            (click)="archiveDocumentDialog()"
          />
          <p-button
            styleClass="customInfoButton outlined"
            label="Eksportuj wybrane"
            [disabled]="!selectedDocuments.length"
            (click)="exportSelected()"
          />
        }

        @if (inboxType() === InboxType.ARCHIVED) {
          <p-button
            styleClass="customInfoButton outlined"
            label="Cofnij archiwizację wybranych"
            [disabled]="!selectedDocuments.length"
            (click)="restoreFromArchiveDocumentDialog()"
          />
          <p-button
            styleClass="customInfoButton outlined"
            label="Eksportuj wybrane"
            [disabled]="!selectedDocuments.length"
            (click)="exportSelected()"
          />
        }

        @if (inboxType() === InboxType.ALL) {
          <p-button
            styleClass="customInfoButton outlined"
            label="Eksportuj wybrane"
            [disabled]="!selectedDocuments.length"
            (click)="exportSelected()"
          />
        }
      </div>
    </div>
  }
  <p-paginator
    (onPageChange)="onPrimePageChange($event)"
    [pageLinkSize]="3"
    [rowsPerPageOptions]="[10, 20, 30]"
    [rows]="tablePage()?.size || 10"
    [totalRecords]="tablePage()?.totalElements || 0"
  />
</div>
